import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';

export function useVideos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'videolar'), orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(
      q,
      snap => {
        const data = snap.docs.map(doc => {
          const d = doc.data();
          return {
            id: doc.id,
            title: d.title || '',
            description: d.description || '',
            videoUrl: d.videoUrl || '',
            thumbnailUrl: d.thumbnailUrl || '',
            createdAt: d.createdAt?.toDate?.() ?? new Date(0),
          };
        });
        setVideos(data);
        setLoading(false);
      },
      err => {
        console.warn('Firestore videos error:', err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return { videos, loading };
}

/* YouTube / Vimeo embed URL dönüştürücü */
export function toEmbedUrl(url) {
  if (!url) return null;
  try {
    // youtube.com/watch?v=ID  →  youtube.com/embed/ID
    const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
    if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

    // youtube.com/shorts/ID
    const shorts = url.match(/youtube\.com\/shorts\/([^?&/]+)/);
    if (shorts) return `https://www.youtube.com/embed/${shorts[1]}`;

    // vimeo.com/ID
    const vim = url.match(/vimeo\.com\/(\d+)/);
    if (vim) return `https://player.vimeo.com/video/${vim[1]}`;

    // Zaten embed URL ise veya doğrudan dosya ise olduğu gibi döndür
    return url;
  } catch {
    return url;
  }
}